module.exports = __webpack_public_path__ + "static/img/creator_country_invite_text1.f8f54f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/creator/creator_country_invite_text1.png
// module id = 6rMo
// module chunks = 0